import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/v1/worklines',
    name: 'POST_WORK_LINES',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
